var map = {
	"./1.jpg": 3380,
	"./10.jpg": 1126,
	"./2.jpg": 5011,
	"./3.jpg": 1846,
	"./4.jpg": 3309,
	"./5.jpg": 4080,
	"./6.jpg": 3724,
	"./7.jpg": 3410,
	"./8.jpg": 2121,
	"./9.jpg": 6748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6294;